import * as React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PillButtonGroup from "./PillButtonGroup";

const segmentSx = (active) => ({
  fontWeight: active ? 600 : 400,
  backgroundColor: active ? "#EBEBEB" : "transparent",
  color: "#333",
  px: 1.25,
  whiteSpace: "nowrap",
  "&:hover": { backgroundColor: active ? "#EBEBEB" : "#f5f5f5" },
});

// Generic "All / current / dropdown" segmented status filter.
// When options.length <= 2 (e.g. Fulfilled/Unfulfilled) every option gets its own segment.
// When options.length > 2, the middle segment always shows the "current" option — the first
// option by default, or whichever one was picked from the dropdown — and the dropdown arrow
// segment stays a plain arrow (never swapped for a label), opening a menu of every option.
export default function SegmentedStatusFilter({ value, onChange, options, disabled }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const showAllPinned = options.length <= 2;

  if (showAllPinned) {
    return (
      <PillButtonGroup disabled={disabled}>
        <Button variant="text" onClick={() => onChange("")} sx={segmentSx(value === "")}>
          All
        </Button>
        {options.map((opt) => (
          <Button key={opt.value} variant="text" onClick={() => onChange(opt.value)} sx={segmentSx(value === opt.value)}>
            {opt.label}
          </Button>
        ))}
      </PillButtonGroup>
    );
  }

  const selectedOption = options.find((o) => o.value === value);
  const currentOption = selectedOption || options[0];

  return (
    <>
      <PillButtonGroup disabled={disabled}>
        <Button variant="text" onClick={() => onChange("")} sx={segmentSx(value === "")}>
          All
        </Button>

        <Button variant="text" onClick={() => onChange(currentOption.value)} sx={segmentSx(value === currentOption.value)}>
          {currentOption.label}
        </Button>

        <Button variant="text" onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ ...segmentSx(false), minWidth: 40, px: 1 }}>
          <ArrowDropDownIcon />
        </Button>
      </PillButtonGroup>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {options.map((opt) => (
          <MenuItem
            key={opt.value}
            selected={opt.value === value}
            onClick={() => {
              onChange(opt.value);
              setAnchorEl(null);
            }}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
